/**
 * @desc 分页
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.ResponseDto<
  defs.tms.PageInfo<defs.tms.LogisticsChannelWarehouseResponseDto>
>;
export function request(
  params: API.tms.logisticsChannelWarehouse.page.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/logisticsChannelWarehouse/page`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
